import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function useGetAllLabelTypes() {
  const [loading, setLoading] = useState(true);
  const [labels, setLabels] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const getAllLabelTypes = () => {
    setLoading(true);
    axiosClient
      .get('/InventoryAddress/GetAllLabelTypes')
      .then(res => {
        if (res.status === 200) {
          setLabels(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, labels, getAllLabelTypes];
}
